import apiService, { ApiService } from './api';
import { BehaviorSubject } from 'rxjs';
import { IAnnouncement } from 'interfaces/announcements';

export class AnnouncementService {
  private Announcement$ = new BehaviorSubject<IAnnouncement | null | undefined>(undefined);

  constructor(private api: ApiService) {}

  public getAnnouncement() {
    if (this.Announcement$.value === undefined) {
      this.Announcement$.next(null);
      this.getAnnouncementFromApi();
    }

    return this.Announcement$.asObservable();
  }

  private getAnnouncementFromApi() {
    this.api.get<IAnnouncement>('/news').subscribe(announcement => {
      if (Object.keys(announcement).length === 0) {
        this.Announcement$.next(null);
        return;
      }

      this.Announcement$.next(announcement);
    });
  }
}

export const AnnouncementServiceFactory = () => new AnnouncementService(apiService);
export const announcementService = AnnouncementServiceFactory();
